import { render, staticRenderFns } from "./favorite-list.vue?vue&type=template&id=089cee59&scoped=true&"
import script from "./favorite-list.vue?vue&type=script&lang=js&"
export * from "./favorite-list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "089cee59",
  null
  
)

export default component.exports